import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { map, Observable, of } from "rxjs";
import { ListOrganisationConnection } from "@graphql/generated";
import { LIST_USERS_ORG_QUERY } from "../graphql/org.query";

@Injectable({
    providedIn: 'root',
})
export class OrgService {
    constructor(private apollo: Apollo) { }

  listUserOrgs(input): Observable<any> {
    return this.apollo.query<{ myOrganisations: ListOrganisationConnection }>({
      query: LIST_USERS_ORG_QUERY,
      variables: {
        pagination: input.pagination,
        filters: input.filters,
      }
    }).pipe(
      map((result) => {
        const organisationConnection = result.data.myOrganisations;
        const activeNodes = organisationConnection.edges
          .map(edge => edge.node)
          .filter(node => node.organisation?.isActive);
        return {
          organisations: activeNodes,
          pageInfo: organisationConnection.pageInfo,
          totalCount: activeNodes.length
        };
      })
    );
  }

}
